export const LEGAL_CANCELLATION_REFUND_POLICY: string = `

### <!--= ++sectionIndex -->. Refund Policy

This section outlines the specific conditions and requirements that apply to the refund policy for our product(s). It is imperative that you review these terms thoroughly. Your eligibility for a refund, in relation to the product(s) purchased, is contingent upon these stipulated conditions.

Please note, in the event that no specific conditions are listed below, it implies that no additional or unique terms apply to your specific product or purchase.

<!-- subSectionIndex = 0; -->

<!-- if (cancellationPolicy.refundPolicies) { -->

<!-- for (const refundPolicy of cancellationPolicy.refundPolicies) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. <!--= refundPolicy.heading -->

<!-- for (const textLine of refundPolicy.texts) { -->
<!--= textLine -->

<!-- } -->

<!-- } -->

<!-- } -->
`;
